import { getRequest } from '../services/requestHandler';
import { PutterFaceForSaveDto } from '../models';

export const getPutterFaces = async () => {
  const url = 'putter/getPutterFaces?activeOnly=true&useCache=false';
  const response = await getRequest<PutterFaceForSaveDto>('GetPutterFaces', url);
  return response;
};
